/** Highest age (in years) a class or event age range may be configured with. */
export const MAX_AGE_YEARS = 100;
